export const ACTIONS_UPDATED = 'actions/ACTIONS_UPDATED';

export const FETCH_ACTIONS_ERROR = 'actions/FETCH_ACTIONS_ERROR';
export const FETCH_ACTIONS_REQUESTED = 'actions/FETCH_ACTIONS_REQUESTED';
export const FETCH_ACTIONS_SUCCESS = 'actions/FETCH_ACTIONS_SUCCESS';